/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CurrencyExchangeConfigurationBase {
    getFixupPrototypeFunction() { return CurrencyExchangeConfigurationBase.fixupPrototype; }

    static newInstance(model: Partial<CurrencyExchangeConfigurationBase>): CurrencyExchangeConfigurationBase {
        let obj = Object.assign(new CurrencyExchangeConfigurationBase(), model);
        CurrencyExchangeConfigurationBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CurrencyExchangeConfigurationBase>): CurrencyExchangeConfigurationBase {
        if (!model) return null;
        return CurrencyExchangeConfigurationBase.newInstance(<CurrencyExchangeConfigurationBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CurrencyExchangeConfigurationBase) {
        if (!obj) return;

        models.CurrencyExchangeConfigurationBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CurrencyExchangeConfigurationBase): boolean {
        Object.setPrototypeOf(obj, CurrencyExchangeConfigurationBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
    }

    /**
     * ID of the Currency Configuration component
     */
    sysId: string;

    /**
     * Created datetime for the component
     */
    created_at: Date;

    /**
     * Updated datetime for the component
     */
    updated_at: Date;

    /**
     * Created by user name
     */
    created_by: string;

    /**
     * Updated by user name
     */
    updated_by: string;

}
